var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTargetArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4998 9.23022C12.0493 9.37189 11.6187 9.57741 11.2217 9.84263C10.3995 10.3921 9.75858 11.173 9.38013 12.0866C9.00168 13.0003 8.90266 14.0057 9.09559 14.9756C9.28852 15.9455 9.76474 16.8365 10.464 17.5358C11.1633 18.235 12.0543 18.7113 13.0242 18.9042C13.9941 19.0971 14.9995 18.9981 15.9131 18.6197C16.8268 18.2412 17.6077 17.6003 18.1571 16.778C18.4224 16.3811 18.6279 15.9505 18.7696 15.5M14.9998 5.0549C13.1458 4.8469 11.273 5.22018 9.64044 6.1231C8.00787 7.02602 6.69624 8.41396 5.88697 10.0949C5.07769 11.7759 4.81079 13.6668 5.12316 15.5061C5.43554 17.3453 6.31176 19.0421 7.63062 20.3616C8.94948 21.6811 10.6458 22.5582 12.4849 22.8715C14.324 23.1848 16.2151 22.9189 17.8964 22.1104C19.5778 21.302 20.9664 19.9911 21.8702 18.359C22.7739 16.7269 23.1481 14.8542 22.9411 13.0001M17 10.9998V7.99973L20.0001 4.99963V7.99973H23.0002L20.0001 10.9998H17ZM17 10.9998L13.9995 13.9998M12.9995 13.9995C12.9995 14.2648 13.1049 14.5191 13.2924 14.7067C13.48 14.8942 13.7343 14.9996 13.9995 14.9996C14.2648 14.9996 14.5191 14.8942 14.7067 14.7067C14.8942 14.5191 14.9996 14.2648 14.9996 13.9995C14.9996 13.7343 14.8942 13.48 14.7067 13.2924C14.5191 13.1049 14.2648 12.9995 13.9995 12.9995C13.7343 12.9995 13.48 13.1049 13.2924 13.2924C13.1049 13.48 12.9995 13.7343 12.9995 13.9995Z",
    stroke: "#121217",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetArrow);
export default __webpack_public_path__ + "static/media/target-arrow.c1a70e26af88fc8d41f99956345bfd06.svg";
export { ForwardRef as ReactComponent };